import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
})
export class DatepickerComponent implements OnInit {
    @Input() label: string = '';
    @Input() fecha: string = ''; // yyyy-MM-dd

    @Output() fechaChange = new EventEmitter<string>();

    abierto: boolean = false;
    pos = { top: 0, left: 0 };

    vista: Date = new Date();

    diasSemana: string[] = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];

    private readonly MESES: string[] = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ];

    ngOnInit(): void {
        this.vista = this.fecha ? this.parse(this.fecha) : new Date();
    }

    toggle(event: MouseEvent): void {
        if (this.abierto) {
            this.abierto = false;
            return;
        }
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.pos = { top: rect.bottom + 6, left: rect.left };
        this.abierto = true;
    }

    cerrar(): void {
        this.abierto = false;
    }

    mesAnterior(): void {
        this.vista = new Date(this.vista.getFullYear(), this.vista.getMonth() - 1, 1);
    }

    mesSiguiente(): void {
        this.vista = new Date(this.vista.getFullYear(), this.vista.getMonth() + 1, 1);
    }

    seleccionarDia(dia: Date): void {
        this.fecha = this.format(dia);
        this.fechaChange.emit(this.fecha);
        this.abierto = false;
    }

    esHoy(dia: Date): boolean {
        const hoy = new Date();
        return (
            dia.getFullYear() === hoy.getFullYear() &&
            dia.getMonth() === hoy.getMonth() &&
            dia.getDate() === hoy.getDate()
        );
    }

    esSeleccionado(dia: Date): boolean {
        if (!this.fecha) {
            return false;
        }
        const sel = this.parse(this.fecha);
        return (
            dia.getFullYear() === sel.getFullYear() &&
            dia.getMonth() === sel.getMonth() &&
            dia.getDate() === sel.getDate()
        );
    }

    get mesLabel(): string {
        return `${this.MESES[this.vista.getMonth()]} ${this.vista.getFullYear()}`;
    }

    get fechaDisplay(): string {
        if (!this.fecha) {
            return '';
        }
        const dia = this.parse(this.fecha);
        return `${this.pad(dia.getDate())}/${this.pad(dia.getMonth() + 1)}/${dia.getFullYear()}`;
    }

    get dias(): (Date | null)[] {
        const primerDia = new Date(this.vista.getFullYear(), this.vista.getMonth(), 1);
        const offset = (primerDia.getDay() + 6) % 7; // lunes = 0
        const diasEnMes = new Date(
            this.vista.getFullYear(),
            this.vista.getMonth() + 1,
            0
        ).getDate();

        const celdas: (Date | null)[] = [];
        for (let i = 0; i < offset; i++) {
            celdas.push(null);
        }
        for (let d = 1; d <= diasEnMes; d++) {
            celdas.push(new Date(this.vista.getFullYear(), this.vista.getMonth(), d));
        }
        return celdas;
    }

    private pad(n: number): string {
        return n < 10 ? '0' + n : '' + n;
    }

    private format(dia: Date): string {
        return `${dia.getFullYear()}-${this.pad(dia.getMonth() + 1)}-${this.pad(dia.getDate())}`;
    }

    private parse(s: string): Date {
        const [y, m, d] = s.split('-').map(Number);
        return new Date(y, m - 1, d);
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        this.abierto = false;
    }
}
